import { render, staticRenderFns } from "./SmartForm.vue?vue&type=template&id=4dd70981&lang=pug&"
import script from "./SmartForm.vue?vue&type=script&lang=ts&"
export * from "./SmartForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports